import { render, staticRenderFns } from "./Lgx331139085617856512.vue?vue&type=template&id=82bad5e4&"
import script from "./Lgx331139085617856512.vue?vue&type=script&lang=js&"
export * from "./Lgx331139085617856512.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports